import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.StatusCajaRutaViewDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
export const columnasFijas: Column[] = [
    { title: "Fecha", cell: x => ({ data: kea.toDate(x.Fecha) }) },
    { title: "Caja", cell: x => ({ data: x.NombreCaja }) },
    { title: "Camion conectado", cell: x => ({ data: x.NombreCamionConectado }) },
    { title: "Camion asignado", cell: x => ({ data: x.NombreCamionAsignado }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    { title: "Viaje", cell: x => ({ data: x.NombreViaje }) },
    { title: "Viaje suc origen", cell: x => ({ data: x.NombreViajeSucursalOrigen }) },
    { title: "Viaje suc destino", cell: x => ({ data: x.NombreViajeSucursalDestino }) },
];
 


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscajaruta/list/columns.tsx